<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Main Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [class.event-navigation-opened]="isEventNavigationOpened"
  [appearance]="mainNavigationAppearance"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="$safeNavigationMigration((navigation$ | async)?.default)"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="sidebar-top" [class.sidebar-top--compact]="isEventNavigationOpened">
      <img
        class="sidebar-top__logo"
        src="../../../../../assets/images/home/logo-360-white.png"
        alt="Organiza360" />
      <user [showAvatar]="false"></user>
    </div>

    @if (!isEventNavigationOpened) {
      <div class="sidebar-context">
        @if (filteredOrgList$ | async; as orgList) {
          <span class="sidebar-context__label">Organização</span>
          @if (selectedOrgInContext; as org) {
            <div class="sidebar-context__card">
              <a class="sidebar-context__main" [routerLink]="['/organizations/dashboard']" [title]="org.name">
                <span class="sidebar-context__icon">
                  <mat-icon svgIcon="heroicons_outline:office-building"></mat-icon>
                </span>
                <span class="sidebar-context__name">{{ org.name }}</span>
              </a>
              @if (orgList.length > 1) {
                <button
                  type="button"
                  class="sidebar-context__action"
                  aria-label="Mudar de organização"
                  [matMenuTriggerFor]="orgListTpl">
                  <mat-icon svgIcon="heroicons_outline:selector"></mat-icon>
                </button>
              }
            </div>
          } @else if (isClubContext && !orgList.length) {
            <a class="sidebar-context__card sidebar-context__card--empty" [routerLink]="['/organizations/details']">
              <span class="sidebar-context__icon">
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </span>
              <span class="sidebar-context__name">Criar associação</span>
            </a>
          } @else {
            <div class="sidebar-context__card sidebar-context__card--empty">
              <span class="sidebar-context__name">
                {{ orgList.length ? 'Sem organização selecionada' : 'Sem organizações disponíveis' }}
              </span>
              @if (orgList.length) {
                <button
                  type="button"
                  class="sidebar-context__action"
                  aria-label="Escolher organização"
                  [matMenuTriggerFor]="orgListTpl">
                  <mat-icon svgIcon="heroicons_outline:selector"></mat-icon>
                </button>
              }
            </div>
          }
        }

        @if (party$ | async; as party) {
          <span class="sidebar-context__label">Festa</span>
          <a class="sidebar-context__card sidebar-context__main" [routerLink]="['/party/details']" [title]="party.name">
            <span class="sidebar-context__icon sidebar-context__icon--party">
              <mat-icon svgIcon="heroicons_outline:sparkles"></mat-icon>
            </span>
            <span class="sidebar-context__name">{{ party.name }}</span>
            <mat-icon class="sidebar-context__chevron" svgIcon="heroicons_outline:chevron-right"></mat-icon>
          </a>
        }
      </div>
    }

    <mat-menu
      [xPosition]="'after'"
      class="sidebar-org-menu"
      #orgListTpl="matMenu">
      <span class="sidebar-org-menu__title">Organizações</span>
      @if (filteredOrgList$ | async; as orgList) {
        @for (item of orgList; track item.id) {
          <button
            mat-menu-item
            (click)="selectThisOrg(item)"
            [class.sidebar-org-menu__item--selected]="selectedOrgInContext?.id === item.id">
            <span>{{ item.name }}</span>
            @if (selectedOrgInContext?.id === item.id) {
              <mat-icon class="sidebar-org-menu__check" svgIcon="heroicons_outline:check"></mat-icon>
            }
          </button>
        }
      }
    </mat-menu>
  </ng-container>
</fuse-vertical-navigation>

<!-- Event Navigation -->
@if (eventNavigation && eventNavigation.length > 0) {
  <fuse-vertical-navigation
    class="dark bg-blue-900 print:hidden event-navigation"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'eventNavigation'"
    [navigation]="eventNavigation"
    [opened]="!isScreenSmall"
    (openedChanged)="updateMainNavigationAppearance()">
    <ng-container fuseVerticalNavigationContentHeader>
      <div class="flex flex-col items-center justify-center w-full p-4 border-b border-blue-700">
        <div class="flex items-center justify-center gap-2 mb-2">
          <mat-icon class="text-yellow-400" [svgIcon]="'heroicons_outline:star'"></mat-icon>
          <span class="text-xs font-semibold text-yellow-400 uppercase tracking-wider">Actividade</span>
        </div>
        <div class="text-sm font-medium text-white text-center truncate w-full px-2" [title]="currentEventName">
          {{ currentEventName }}
        </div>
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

  <!-- Header -->
  @if (showLayoutHeader) {
    <div
      class="layout-header print:hidden dark:shadow-none dark:border-b dark:bg-transparent"
      >
      <!-- Navigation toggle buttons -->
      <div class="flex items-center gap-2">
        <button class="hamburger-menu" mat-icon-button (click)="toggleNavigation('mainNavigation')">
          <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
      </div>
      <!-- Right Section -->
      <div class="flex items-center space-x-4 ml-auto">
        <!-- Event Navigation Toggle Button (Mobile Only) -->
        @if (isScreenSmall && eventNavigation && eventNavigation.length > 0) {
          <button
            class="event-nav-toggle"
            mat-icon-button
            (click)="toggleNavigation('eventNavigation')"
            [attr.aria-label]="'Abrir menu de navegação de eventos'">
            <mat-icon [svgIcon]="'heroicons_outline:dots-vertical'"></mat-icon>
          </button>
        }
        @if (showClubYearSelector) {
          <div class="flex items-center">
            <button mat-stroked-button class="org-year-trigger" [matMenuTriggerFor]="organizationYearMenu">
              <mat-icon class="org-year-icon" [svgIcon]="'heroicons_outline:calendar'"></mat-icon>
              <span>Ano {{ selectedOrganizationYear }}</span>
              <mat-icon class="org-year-chevron" [svgIcon]="'mat_solid:keyboard_arrow_down'"></mat-icon>
            </button>
          </div>
        }
        @if (showPartyTrialBanner) {
          <div class="flex items-center space-x-4">
            <!-- Text Information -->
            @if (daysToExpire > 1) {
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">
                Restam {{ daysToExpire }} dias de teste
              </span>
            }
            @if (daysToExpire === 1) {
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">
                Resta {{ daysToExpire }} dia de teste
              </span>
            }
            @if (daysToExpire < 1) {
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">
                O período de teste expirou
              </span>
            }
            <button mat-raised-button color="primary" class="btn-primary" [routerLink]="'/payments/bank-transfer'">
              Subscrever
            </button>
          </div>
        }
        @if (showClubUpgradeBanner) {
          <div class="flex items-center space-x-4">
            @if (clubPlanIsTrial && clubPlanDaysToExpire > 1) {
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">
                Restam {{ clubPlanDaysToExpire }} dias de teste
              </span>
            }
            @if (clubPlanIsTrial && clubPlanDaysToExpire === 1) {
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">
                Resta {{ clubPlanDaysToExpire }} dia de teste
              </span>
            }
            @if (clubPlanIsReadOnly && clubPlanIsTrial) {
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">
                O período de teste terminou. A associação está em modo leitura.
              </span>
            }
            @if (clubPlanIsReadOnly && !clubPlanIsTrial) {
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">
                O plano expirou. A associação está em modo leitura.
              </span>
            }
            <button mat-raised-button color="primary" class="btn-primary" [routerLink]="'/payments/bank-transfer'">
              {{ clubUpgradeCtaLabel }}
            </button>
          </div>
        }
      </div>
    </div>
  }

  <mat-menu
    [xPosition]="'before'"
    #organizationYearMenu="matMenu">
    @for (year of availableOrganizationYears; track year) {
      <button
        mat-menu-item
        (click)="selectOrganizationYear(year)"
        [ngClass]="{'selected-item': selectedOrganizationYear === year}">
        @if (selectedOrganizationYear === year) {
          <mat-icon [svgIcon]="'heroicons_solid:check'"></mat-icon>
        }
        <span>{{ year }}</span>
      </button>
    }
  </mat-menu>


  <!-- Content -->
  <div class="layout-body-content flex flex-col flex-auto" [class.layout-body-content--with-header]="showLayoutHeader">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <div
    class="mt-6 relative w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden grid grid-cols-1 sm:grid-cols-3">
    <div class="flex flex-wrap sm:flex-nowrap sm:col-span-3 items-center">
      <span class="font-medium text-secondary mr-4">Organiza360 &copy; {{ currentYear }}</span>
      <a
        class="mr-4 sm:ml-auto hover:underline"
        [routerLink]="['/terms-conditions']" [queryParams]="{p: 'inner'}">Termos e Condições
      </a>
      <a
        class="mr-4 hover:underline"
        [routerLink]="['/privacy']" [queryParams]="{p: 'inner'}">Politicas e privacidade
      </a>
      <a
        class="hover:underline"
        [routerLink]="['/cookies']" [queryParams]="{p: 'inner'}">Cookies
      </a>
    </div>
  </div>


</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
